module.exports = __webpack_public_path__ + "static/media/IMAGEN - COCINA MOLECULAR - .a659f7f0.jpg";